import { IContextualMenuItem, useTheme } from "@bps/fluent-ui";
import { useStores } from "@stores/hooks/useStores.ts";
import { NavLink } from "@ui-components/navigation/Nav.tsx";

export const useContextualMenuItem = (navLink: NavLink) => {
  const { core, routing } = useStores();
  const theme = useTheme();

  const convertToContextualMenu = (
    navLinks: NavLink[]
  ): IContextualMenuItem[] => {
    const items: IContextualMenuItem[] = [];

    navLinks.forEach(navLink => {
      const permissions =
        navLink.permissions ?? navLink.path?.permissions ?? [];

      const permissionsOperator =
        navLink.permissionsOperator ??
        navLink.path?.permissionsOperator ??
        "and";

      if (
        permissions.length &&
        !core.hasPermissions(permissions, permissionsOperator)
      ) {
        return;
      }

      const subItems = navLink.links?.length
        ? convertToContextualMenu(navLink.links)
        : undefined;

      if (navLink.links?.length && !subItems?.length) {
        return;
      }

      const onClick =
        navLink.onClick ||
        (navLink.url || navLink.path
          ? () => routing.push(navLink.url ?? navLink.path?.pattern ?? "")
          : undefined);

      items.push({
        key: navLink.name,
        text: navLink.name,
        items: subItems,
        onClick,
        style: {
          borderBottom: navLink.showBorder
            ? `1px solid ${theme.palette.neutralLight}`
            : undefined
        }
      });
    });

    return items;
  };

  const items = convertToContextualMenu([navLink]);

  if (items.length) {
    return items[0];
  }

  return undefined;
};
